import Image from "next/image";
import Meta from "@/components/templates/Meta";
import { Header } from "@/components/templates/Header";
import { Footer } from "@/components/templates/Footer";
import Layout from "@/components/templates/Layout";
import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
import { TLink } from "@/components/molecules/Button";
import { useBudouX } from "@/hooks/useBudouX";
import { BreadCrumb } from "@/components/organisms/BreadCrumb";
import Contact from "@/components/organisms/Contact";
import { Interviewee, Interviewer } from "@/components/organisms/InterviewItem";
import { VoiceCover } from "@/components/organisms/VoiceCover";
import { VoiceNav } from "@/components/organisms/VoiceNav";
import voicePhoto from "/public/voice-photo1.webp";
import voicePhotoB from "/public/voice-photo1b.webp";

export default function CareerArticle(props) {
  const { parse } = useBudouX();
  const isHeaderRelative = true;
  return (
    <>
      <Meta
        pageTitle={
          "Voices:メンバーの声 No.1 上流工程から案件に携われる環境が成長の要因"
        }
        pageDescription={
          "株式会社トッカシステムズのVoices:メンバーの声 No.1 上流工程から案件に携われる環境が成長の要因。日進月歩のデジタルテクノロジー分野において『お客様のビジネスに特化（Tocca）したシステムを』という理念を社名に込めて、使える・価値のあるシステムを提供します。"
        }
        pagePath={"https://tocca.systems/careers/voice/1"}
      />
      <Layout className="relative">
        <div className="absolute z-0 aspect-1/1 w-full bg-voices-no1 xs:max-h-[300px] sm:max-h-[300px] md:aspect-1/1 md:max-h-[500px] lg:max-h-[640px]"></div>
        <Header isRelative={isHeaderRelative} />
        <main className="z-10 flex-1">
          <Container>
            <BreadCrumb
              lists={[
                {
                  name: "TOP",
                  path: "/",
                },
                {
                  name: "Careers",
                  path: "/",
                },
                {
                  name: "Voices:メンバーの声 No.1",
                },
              ]}
            />
            <Inner className="max-w-full">
              <div className="mx-auto flex max-w-6xl flex-col">
                <VoiceCover
                  title="上流工程から案件に携われる環境が成長の要因"
                  avatar="G.Oさん - 2015年入社"
                />
                <figure className="relative mt-6 block aspect-2/1 w-full group-hover:opacity-80 md:mt-8 lg:mt-10">
                  <Image
                    src={voicePhoto}
                    alt="上流工程から案件に携われる環境が成長の要因 G.Oさん - 2015年入社"
                    quality={80}
                    layout="fill"
                    objectFit="cover"
                  />
                </figure>
              </div>
              <div
                className="mx-auto
                max-w-2xl
                space-y-3
                py-6
                leading-loose
                text-txt-base
                md:space-y-4
                md:py-8
                lg:space-y-6
                lg:pt-14
                lg:pb-20"
              >
                <Interviewer>
                  ToccaSystemsに入った時の印象を教えてください
                </Interviewer>
                <Interviewee>
                  私が入社（大卒後2社目）した頃は、人数も今のように多くはなく、オフィスもずっと手狭でした。取締役が、とても気さくだったことが印象に残っています。前職は、サポートデスクでカスタマーへの対応を行っていました。
                </Interviewee>
                <Interviewer>
                  では、エンジニアとしてのキャリアはToccaSystemsに入ってからですか？
                </Interviewer>
                <Interviewee>
                  そうですね。入社をした時は、本当に未経験だったのでやれるのかと、当初は不安が大きかったです。はじめはhtmlとphpを中心に学習をしました。最初はわけが分からなかったですが...（笑）未経験でも、社内研修プログラムを利用することができたので「これを続けていけば良いんだ」と思うことができました。今では飛び込んでみて良かったと思っています。
                </Interviewee>
                <Interviewer>
                  現在はどのような、業務についているのですか？
                </Interviewer>
                <Interviewee>
                  クライアントからのヒアリング、またヒアリングを基にした提案業務がメインです。前職での経験が役に立つので、クライアントと話をするほうが好きですね（笑）チームとして、プロジェクトを進めていくので、提案後の工程はチーム内のプログラマに引き継いでいます。
                </Interviewee>
                <div className="relative aspect-1.91/1">
                  <Image
                    src={voicePhotoB}
                    alt="【Voices: メンバーの声 No.1】 インタビューカット"
                    quality={80}
                    layout="fill"
                    objectFit="cover"
                  />
                </div>
                <Interviewer>技術を知らないと提案できませんよね？</Interviewer>
                <Interviewee>
                  そうですね。技術をすべて把握しているわけでないですが、どういった技術があって、今は何が最新の技術なのかは、日頃から追いかけながら仕事をしています。
                </Interviewee>
                <Interviewer>
                  6年勤続できている理由は何だと思いますか？
                </Interviewer>
                <Interviewee>
                  正直にいうと、プログラムを書くことが大好きというわけではないです（笑）。
                  だからクライアントからのヒアリングや、提案という上流工程から、プロジェクトに関わることのできる、ToccaSystemsだから長く続けられているような気がします。
                </Interviewee>
                <Interviewer>
                  最後に、一緒に働いてみたいと思う人を教えてください。
                </Interviewer>
                <Interviewee>
                  技術があるかどうかは、あまり重要ではないと思っています。自分もそうでしたが、入社後に仕事の中で身に着けていければ良いので。もちろん、初めから技術のあるという人もすごいと思います。それよりも、こちらの問いかけに自分自身で深堀りをして、きちんと考えよう、学ぼうという姿勢を持っているかどうかが大事だと思います。
                </Interviewee>
                <div className="flex justify-end px-8 md:px-0">
                  <TLink href="/careers/" variant="mono" color="ff">
                    Carrers top
                  </TLink>
                </div>
              </div>
              <VoiceNav />
            </Inner>
          </Container>
        </main>
        <Contact />
        <Footer />
      </Layout>
    </>
  );
}
